import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getServiceComplaints } from 'src/api/service-complaints';
import {
    FETCH_SERVICE_COMPLAINTS,
    requestServiceComplaints,
    requestServiceComplaintsFailure,
    requestServiceComplaintsSuccess,
} from './actions';

function* fetchServiceComplaintsSaga(): SagaIterator {
    yield put(requestServiceComplaints());

    const { error, response } = yield call(getServiceComplaints);

    if (error) {
        yield put(requestServiceComplaintsFailure(error));
    } else {
        yield put(requestServiceComplaintsSuccess(response));
    }
}

export function* generateFetchServiceComplaintsWatcher() {
    yield takeLatest(FETCH_SERVICE_COMPLAINTS, fetchServiceComplaintsSaga);
}
